export const probe = {
  visible: true,
  active: false,
  handles: {
    end: {
      x: "",
      y: "",
      highlight: true,
      active: false
    }
  },
  invalidated: true
};
